import type * as t from "./types";
import type { SequenceNode } from "./sequence";

import { derived, writable } from "svelte/store";

export type State = {
    config: t.QuizConfig;
    score: Record<string, number>;
    globalStepIdx: number;
    segment: SequenceNode<t.Segment>;
    step: SequenceNode<t.Step>;
    totalSteps: number;
    klaviyoConfig: t.QuizProps["klaviyoConfig"];
};

const store = writable<State>();
const currentSegment = derived(store, ($s) => $s?.segment);

export function init(state: State) {
    store.set(state);
}

export default store;
export { currentSegment };
